﻿import React, { useState, useEffect } from 'react';
import MethodColumnComponent from './MethodColumnComponent';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import { MethodDetail } from '../../models/Methods/method-detail';
import { CrudFunctions } from '../../utilities/crud-functions';
import { Method } from '../../models/Methods/method';
import { Gradient } from '../../models/Methods/gradient';
import { FieldUpdate } from '../../models/field-update';
import { TemperatureProgram } from '../../models/Methods/temperature-program';
import SolventsLookup from '../Solvents/SolventsLookup';
import { SolventConfiguration } from '../../models/Solvents/solvent-configuration';
import { ItemBasicInformation } from '../../models/item-basic-information';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { BenchSheetTechnologyType, ModalMessageType } from '../../models/enums';
import { ToastProps } from '../../models/toast-props';
import { LookupItem } from '../../models/lookup-item';

import DataGrid, {
    Column,
    Selection,
    Button as ColumnButton,
    Toolbar,
    Item as ToolbarItem,
    Editing,
    Paging,
    LoadPanel
} from 'devextreme-react/data-grid';

import {
    Validator,
    StringLengthRule
} from 'devextreme-react/validator';

import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import NumberBox from 'devextreme-react/number-box';
import Button from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Toast } from 'devextreme-react/toast';

const gases: LookupItem[] = [
    { id: 1, name: 'H', description: 'Hydrogen' },
    { id: 2, name: 'He', description: 'Helium' },
    { id: 3, name: 'N', description: 'Nitrogen' }
]

let key = 0;

export interface Props {
    methodId: string;
    selectedMethod?: Method;
    readOnly: boolean;
}

export default function GcMethodDetailsComponent(props: Props) {
    const [methodDetail, setMethodDetail] =
        useState<MethodDetail>();

    const [selectedTemperatureProgram, setSelectedTemperatureProgram] =
        useState<TemperatureProgram>();

    const [solventLookupVisible, setSolventLookupVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>(false);

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getMethodDetails();
       // getTemperatureProgramByMethodId();
    }, [props.methodId]);

    //this is needed, otherwise Description gets overwritten by the previous value 
    useEffect(() => {
        setDataLoaded(true);
    }, [methodDetail]);

    key++;

    return (
        <div className="dma-bg-light-blue pw-margin-top-1 pw-margin-bottom-1">
            <div>
                <div className="pw-comp-row pw-margin-top-1">
                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Solvent Name</div>
                        <TextBox id="solventName" className="textbox" readOnly={true}
                            disabled={props.readOnly}
                            placeholder="NA"
                            value={methodDetail && methodDetail.solventName ? methodDetail.solventName : undefined} />
                    </div>

                    <div className="pw-row-button-08">
                        <Button className="title-bar-button"
                            text="" icon="search" type="success"
                            hint="lookup solvent"
                            onClick={showSolventsLookupDialog} />
                    </div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Detectors</div>
                        <TextBox id="detectors" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.detectors ? methodDetail.detectors : undefined} />
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Detector Temp.</div>
                        <NumberBox id="detectorTemperature" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.detectorTemperature ? methodDetail.detectorTemperature : undefined} />
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Injection Port Temp.</div>
                        <NumberBox id="injectionPortTemperature" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.injectionPortTemperature ? methodDetail.injectionPortTemperature : undefined} />
                    </div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Flow Rate</div>
                        <NumberBox id="flowRate" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.flowRate ? methodDetail.flowRate : undefined} />
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Injection Volume</div>
                        <NumberBox id="injectionVolume" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.injectionVolume ? methodDetail.injectionVolume : undefined} />
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Split Ratio</div>
                        <TextBox id="splitRatioString" className="textbox"
                            onValueChanged={onValueChanged} disabled={true}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.splitRatioString ? methodDetail.splitRatioString : undefined} />
                    </div>

                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Carrier Gas</div>
                        <SelectBox id="carrierGas" className="textbox"
                            dataSource={gases ? gases : []}
                            valueExpr='id' displayExpr="name"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            placeholder="NA"
                            value={methodDetail && methodDetail.carrierGas ? methodDetail.carrierGas : undefined} />
                    </div>
                </div>

                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Traceability</div>
                    <TextBox id="traceability" className="textbox"
                        readOnly={props.readOnly} placeholder='NA'
                        onValueChanged={onValueChanged}
                        value={methodDetail && methodDetail.traceability ? methodDetail.traceability : undefined}>
                        <Validator>
                            <StringLengthRule message="Part Number must be less than 100 characters in length." max={100} />
                        </Validator>
                    </TextBox>
                </div>

                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Internal Standard</div>
                    <TextBox id="internalStandard" className="textbox"
                        readOnly={props.readOnly} placeholder='NA'
                        onValueChanged={onValueChanged}
                        value={methodDetail && methodDetail.internalStandard ? methodDetail.internalStandard : undefined}>
                        <Validator>
                            <StringLengthRule message="Part Number must be less than 100 characters in length." max={100} />
                        </Validator>
                    </TextBox>
                </div>

                <div className="pw-comp-row">
                    {/*
                            <div className="pw-form-unit pw-comp-10">
                                <div className="pw-form-unit-label">Column Temperature</div>
                                <NumberBox id="columnTemperature" className="textbox"
                                    onValueChanged={onValueChanged} disabled={props.readOnly}
                                    showClearButton={true} placeholder="NA"
                                    value={methodDetail && methodDetail.columnTemperature ? methodDetail.columnTemperature : undefined} />
                            </div>

                            
                            <div className="pw-form-unit pw-comp-10">
                                <div className="pw-form-unit-label">Scan Type</div>
                                <SelectBox id="scanType" className="textbox"
                                    dataSource={scanTypes ? scanTypes : []}
                                    valueExpr='id' displayExpr="name"
                                    onValueChanged={onValueChanged} disabled={props.readOnly}
                                    placeholder="NA"
                                    value={methodDetail && methodDetail.scanType ? methodDetail.scanType : undefined} />
                            </div>
                            
                            <div className="pw-form-unit pw-comp-10">
                                <div className="pw-form-unit-label">Mass Range Start</div>
                                <NumberBox id="massRangeStart" className="textbox"
                                    onValueChanged={onValueChanged} disabled={props.readOnly}
                                    showClearButton={true} placeholder="NA"
                                    value={methodDetail && methodDetail.massRangeStart ? methodDetail.massRangeStart : undefined} />
                            </div>
                            <div className="pw-form-unit pw-comp-10">
                                <div className="pw-form-unit-label">Mass Range End</div>
                                <NumberBox id="massRangeEnd" className="textbox"
                                    onValueChanged={onValueChanged} disabled={props.readOnly}
                                    showClearButton={true} placeholder="NA"
                                    value={methodDetail && methodDetail.massRangeEnd ? methodDetail.massRangeEnd : undefined} />
                            </div>
                            */}
                </div>
            </div>

            <div className="pw-form-unit">
                <DataGrid height="16rem"
                    wordWrapEnabled={true}
                    keyExpr="temperatureProgramId"
                    dataSource={methodDetail && methodDetail.temperaturePrograms ?
                        methodDetail.temperaturePrograms : []}
                    onSelectionChanged={temperatureProgramSelectionChanged}
                    onRowValidating={onTemperatureProgramDataValidating}
                    onRowRemoving={onTemperatureProgramRowRemoving}
                    onInitNewRow={onAddTemperatureProgramEntry}
                    showRowLines={true}

                    rowAlternationEnabled={true}
                    showBorders={true} >

                    <LoadPanel enabled={true} />
                    <Selection mode='single' />
                    <Paging enabled={false} />

                    <Column name="bc0" type="buttons" width='6rem'>
                        <ColumnButton hint="information" icon="info"
                            onClick={onTemperatureProgramInfoButtonClick} />
                        <ColumnButton name="edit" />
                        <ColumnButton name="save" />
                        <ColumnButton name="delete" />
                    </Column>

                    <Column dataField='rowNumber' caption="" dataType="number"
                        allowEditing={false} width='3rem' />
                    <Column dataField='initTemperature' caption="Init Temp °C" dataType="number" width='21%' />
                    <Column dataField='timeIncrement1' caption="Hold Time (min)" dataType="number"
                        width='18%' />
                    <Column dataField='secondTemperature' caption="Second Temp °C" dataType="number" width='21%' />
                    <Column dataField='timeIncrement2' caption="Hold Time (min)" dataType="number"
                        width='18%' />
                    <Column dataField='rate' caption="Rate °C/min" dataType="number" width='22%' />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Temperature Program</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem location='after'>
                            <Button width='1.9rem' type='normal' icon="repeat"
                                hint="duplicate rows"
                                onClick={duplicateTemperatureProgramRow} />
                        </ToolbarItem>

                        {!props.readOnly &&
                            <ToolbarItem location='after' name="addRowButton" />
                        }

                    </Toolbar>

                    {!props.readOnly &&
                        <Editing mode="row"
                            useIcons={true}
                            allowAdding={true}
                            allowUpdating={true}
                            allowDeleting={true}
                            newRowPosition="last" />
                    }

                </DataGrid>
            </div>

            <div className="pw-form-unit pw-margin-top-1 pw-padding-bottom-05">
                <MethodColumnComponent methodId={props.methodId}
                    technologyId={BenchSheetTechnologyType.GasChromatography}
                    readOnly={props.readOnly} />
            </div>

            {solventLookupVisible &&
                <DialogPopup visible={solventLookupVisible}
                    onHiding={hideSolventsLookupDialog}
                    title="Solvent Lookup"
                    width='50vw'
                    height='50vh'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <SolventsLookup onApplySelection={onSolventsLookupApplySelection}
                        onCancel={hideSolventsLookupDialog}
                        key={`SL${key}`} />
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div >
    );

    function temperatureProgramSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedTemperatureProgram(e.selectedRowsData[0]);
        }
    }

    function onMethodValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && methodDetail && methodDetail.methodId) {
            const m = methodDetail as any;
            const currentValue = m[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                let fieldUpdate: FieldUpdate = {
                    field: caller,
                    value: e.value,
                    rowId: methodDetail.methodId
                };

                updateMethodField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Method Field");
                    })
            }

            setMethodDetail({ ...methodDetail, [caller]: e.value });
        }
    }

    async function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && methodDetail) {
            const m = methodDetail as any;
            const currentValue = m[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                let fieldUpdate: FieldUpdate = {
                    field: caller,
                    value: e.value,
                    rowId: methodDetail.methodId
                };

                await updateMethodDetailField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Method Detail Field");
                    })
            }
        }

        setMethodDetail({ ...methodDetail, [caller]: e.value });
    }

    function duplicateTemperatureProgramRow(e: any) {

    }

    function onAddTemperatureProgramEntry(e: any) {
        if (!methodDetail || !methodDetail.temperaturePrograms) {
            //todo notify
            return;
        }

        const entryCount = methodDetail.temperaturePrograms.length;
        const newRowNumber = entryCount ? entryCount + 1 : 1

        let newTemperatureProgramEntry: TemperatureProgram = {
            rowNumber: newRowNumber
        };

        e.data = newTemperatureProgramEntry;
    }

    async function onTemperatureProgramDataValidating(e: any) {
        if (!dataLoaded)
            return;

        if (e.oldData) {
            let temperatureProgram = e.oldData as TemperatureProgram;

            if (temperatureProgram) {
                let updatedTemperatureProgram = { ...temperatureProgram, ...e.newData };

                updateTemperatureProgram(updatedTemperatureProgram)
                    .then(() => {
                        showToast("Temperature Program updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Temperature Program ");
                    });
            }
        }
        else {
            if (e.newData) {
                let temperatureProgram = e.newData as TemperatureProgram;

                if (props.methodId) {
                    temperatureProgram.methodId = props.methodId;

                    await insertTemperatureProgram(temperatureProgram)
                        .then(() => {
                            showToast("Temperature Program saved", "success");
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Temperature Program");
                        });
                }
            }
        }
    }

    function onTemperatureProgramRowRemoving(e: any) {

    }

    async function onTemperatureProgramRowRemoveClick(e: any) {
        if (selectedTemperatureProgram && selectedTemperatureProgram.temperatureProgramId) {
            await deleteTemperatureProgram(selectedTemperatureProgram.temperatureProgramId)
                .then(() => {
                    showToast("Temperature Program Deleted", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Temperature Program");
                });
        }
    }

    function onAddGradientClick(e: any) {

    }

    async function onGradientsValidating(e: any) {
        if (!dataLoaded)
            return;

        if (e.oldData) {
            let gradient = e.oldData as Gradient;

            if (gradient) {
                let updatedGradient = { ...gradient, ...e.newData };

                updateGradient(updatedGradient)
                    .then(() => {
                        showToast("Gradient updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Gradient");
                    });
            }
        }
        else {
            if (e.newData) {
                let gradient = e.newData as Gradient;

                if (props.methodId) {
                    gradient.methodId = props.methodId;

                    await insertGradient(gradient)
                        .then(() => {
                            showToast("Gradient saved", "success");
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Gradient");
                        });
                }
            }
        }
    }

    function onGradientsRowRemoving(e: any) {

    }

    function onGradientsRowRemoveClick(e: any) {

    }

    function onSolventsLookupApplySelection(solvent: SolventConfiguration) {

        //todo - save to database


        if (solvent && solvent.macolaSolvent) {
            let editedMethodDetail = { ...methodDetail };

            editedMethodDetail.solventName = solvent.macolaSolvent;

            setMethodDetail(editedMethodDetail);
            hideSolventsLookupDialog();
        }
        else {
            //show info dialog - "No solvent found"

        }
    }

    async function getMethodDetails() {
        if (props.methodId) {
            setDataLoaded(false);

            await CrudFunctions.getData(`methods/methoddetail/${props.methodId}`)
                .then(data => {

                    console.log("GC method details...");
                    console.log(data);

                    setMethodDetail(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Method Details");
                });
        }
        else {
            setMethodDetail(null);
        }
    }

    async function getTemperatureProgramByMethodId() {
        if (props.methodId) {
            await CrudFunctions.getData(`methods/temperatureprograms/${props.methodId}`)
                .then(data => {
                   // setMethodDetail(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Method Temperature Program");
                });
        }
        else {
            
        }
    }

    async function insertMethod(method: Method) {
        return await CrudFunctions.postData("methods/method", method);
    }

    async function insertGradient(gradient: Gradient) {
        return await CrudFunctions.postData("methods/gradient", gradient);
    }

    async function updateMethodField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("methods/methodfield", fieldUpdate);
    }

    async function updateMethodDetailField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("methods/methoddetailfield", fieldUpdate);
    }

    async function updateGradient(gradient: Gradient) {
        return await CrudFunctions.putData("methods/gradient", gradient);
    }

    async function insertTemperatureProgram(temperatureProgram: TemperatureProgram) {
        return await CrudFunctions.postData("methods/temperatureprogram", temperatureProgram);
    }

    async function updateTemperatureProgram(temperatureProgram: TemperatureProgram) {
        return await CrudFunctions.putData("methods/temperatureprogram", temperatureProgram);
    }

    async function deleteGradient(gradientId: string) {
        return await CrudFunctions.deleteData(`methods/gradient/${gradientId}`);
    }

    async function deleteTemperatureProgram(temperatureProgramId: string) {
        return await CrudFunctions.deleteData(`methods/temperatureProgram/${temperatureProgramId}`);
    }

    async function getAllData() {
        // await getScanTypes().then(() => {
        setDataLoaded(true)
        // });
    }

    function onTemperatureProgramInfoButtonClick(e: any) {
        if (e.row && e.row.data) {
            const temperatureProgram = e.row.data as TemperatureProgram;

            if (temperatureProgram) {
                setSelectedTemperatureProgram(temperatureProgram);

                let itemInformation: ItemBasicInformation = {
                    rowPointer: temperatureProgram.temperatureProgramId,
                    createTimestamp: temperatureProgram.createTimestamp,
                    lastModifiedTimestamp: temperatureProgram.modifyTimestamp,
                    createUser: temperatureProgram.createUser,
                    modifyUser: temperatureProgram.modifyUser
                };

                setItemBasicInformation(itemInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showSolventsLookupDialog() {
        setSolventLookupVisible(true);
    }

    function hideSolventsLookupDialog() {
        setSolventLookupVisible(false);
    }


    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}